import script from "./ReportsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsPage.vue?vue&type=script&setup=true&lang=js"

import "./ReportsPage.vue?vue&type=style&index=0&id=5c53fd64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c53fd64"]])

export default __exports__